import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAuth } from '../components/auth/AuthContext';
import {
  Container,
  Typography,
  TextField,
  Button,
  Box,
} from '@mui/material';
import axios from 'axios';

const PublishEvent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { schoolId: contextSchoolId } = useAuth();
  const schoolId = location.state?.schoolId || contextSchoolId;

  const [eventName, setEventName] = useState('');
  const [dateTime, setDateTime] = useState('');
  const [venue, setVenue] = useState('');
  const [organizer, setOrganizer] = useState('');
  const [objective, setObjective] = useState('');
  const [targetAudience, setTargetAudience] = useState('');
  const [eventTheme, setEventTheme] = useState('');
  const [schedule, setSchedule] = useState('');
  const [keySpeakers, setKeySpeakers] = useState('');
  const [workshops, setWorkshops] = useState('');
  const [entryRequirements, setEntryRequirements] = useState('');
  const [parkingTransport, setParkingTransport] = useState('');
  const [cateringRefreshments, setCateringRefreshments] = useState('');
  const [dressCode, setDressCode] = useState('');
  const [sponsorships, setSponsorships] = useState('');
  const [contactInformation, setContactInformation] = useState('');

  const handlePublishEvent = async () => {
    if (!schoolId) {
      alert('Error: School ID is missing. Please log in again.');
      return;
    }

    const eventData = {
      eventName,
      dateTime,
      venue,
      organizer,
      objective,
      targetAudience,
      eventTheme,
      schedule,
      keySpeakers,
      workshops,
      entryRequirements,
      parkingTransport,
      cateringRefreshments,
      dressCode,
      sponsorships,
      contactInformation,
      schoolId,
    };

    try {
      const response = await axios.post('https://kidsm.vercel.app/api/schools/publish-event', eventData);
      if (response.status === 201) {
        alert('Success: Event published successfully!');
        navigate(-1);
      }
    } catch (error) {
      console.error('Error publishing event:', error.response?.data || error.message);
      alert('Error: ' + (error.response?.data?.message || 'Failed to publish event. Please try again.'));
    }
  };

  return (
    <Container maxWidth="md" sx={{ py: 4, bgcolor: '#f8f9fa', minHeight: '100vh' }}>
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
        <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#2c3e50', mb: 3 }}>
          Publish Event
        </Typography>
        <Box component="form" sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <TextField
            label="Event Name"
            value={eventName}
            onChange={(e) => setEventName(e.target.value)}
            fullWidth
            variant="outlined"
            sx={{ bgcolor: '#fff' }}
          />
          <TextField
            label="Date & Time (e.g., 2023-12-25T10:00)"
            value={dateTime}
            onChange={(e) => setDateTime(e.target.value)}
            fullWidth
            variant="outlined"
            sx={{ bgcolor: '#fff' }}
          />
          <TextField
            label="Venue/Location"
            value={venue}
            onChange={(e) => setVenue(e.target.value)}
            fullWidth
            variant="outlined"
            sx={{ bgcolor: '#fff' }}
          />
          <TextField
            label="Organizer"
            value={organizer}
            onChange={(e) => setOrganizer(e.target.value)}
            fullWidth
            variant="outlined"
            sx={{ bgcolor: '#fff' }}
          />
          <TextField
            label="Objective"
            value={objective}
            onChange={(e) => setObjective(e.target.value)}
            fullWidth
            variant="outlined"
            sx={{ bgcolor: '#fff' }}
            multiline
            rows={3}
          />
          <TextField
            label="Target Audience"
            value={targetAudience}
            onChange={(e) => setTargetAudience(e.target.value)}
            fullWidth
            variant="outlined"
            sx={{ bgcolor: '#fff' }}
          />
          <TextField
            label="Event Theme"
            value={eventTheme}
            onChange={(e) => setEventTheme(e.target.value)}
            fullWidth
            variant="outlined"
            sx={{ bgcolor: '#fff' }}
          />
          <TextField
            label="Schedule"
            value={schedule}
            onChange={(e) => setSchedule(e.target.value)}
            fullWidth
            variant="outlined"
            sx={{ bgcolor: '#fff' }}
            multiline
            rows={3}
          />
          <TextField
            label="Key Speakers/Performers"
            value={keySpeakers}
            onChange={(e) => setKeySpeakers(e.target.value)}
            fullWidth
            variant="outlined"
            sx={{ bgcolor: '#fff' }}
          />
          <TextField
            label="Workshops/Sessions"
            value={workshops}
            onChange={(e) => setWorkshops(e.target.value)}
            fullWidth
            variant="outlined"
            sx={{ bgcolor: '#fff' }}
            multiline
            rows={3}
          />
          <TextField
            label="Entry Requirements"
            value={entryRequirements}
            onChange={(e) => setEntryRequirements(e.target.value)}
            fullWidth
            variant="outlined"
            sx={{ bgcolor: '#fff' }}
          />
          <TextField
            label="Parking & Transport"
            value={parkingTransport}
            onChange={(e) => setParkingTransport(e.target.value)}
            fullWidth
            variant="outlined"
            sx={{ bgcolor: '#fff' }}
          />
          <TextField
            label="Catering & Refreshments"
            value={cateringRefreshments}
            onChange={(e) => setCateringRefreshments(e.target.value)}
            fullWidth
            variant="outlined"
            sx={{ bgcolor: '#fff' }}
          />
          <TextField
            label="Dress Code"
            value={dressCode}
            onChange={(e) => setDressCode(e.target.value)}
            fullWidth
            variant="outlined"
            sx={{ bgcolor: '#fff' }}
          />
          <TextField
            label="Sponsorships & Partnerships"
            value={sponsorships}
            onChange={(e) => setSponsorships(e.target.value)}
            fullWidth
            variant="outlined"
            sx={{ bgcolor: '#fff' }}
          />
          <TextField
            label="Contact Information"
            value={contactInformation}
            onChange={(e) => setContactInformation(e.target.value)}
            fullWidth
            variant="outlined"
            sx={{ bgcolor: '#fff' }}
          />
          <Button
            variant="contained"
            sx={{ bgcolor: '#6200ee', mt: 2 }}
            onClick={handlePublishEvent}
          >
            Publish Event
          </Button>
        </Box>
      </motion.div>
    </Container>
  );
};

export default PublishEvent;